// frontend/src/components/ToolCard/ToolCard.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const ToolCard = ({ tool, onToolClick }) => {
  const { t, i18n } = useTranslation();
  if (tool.page_slug === 'Ask-arXiv') {
    return null;
  }
  const lang = i18n.language.split('-')[0];

  const displayName = tool[`display_name_${lang}`] || tool.display_name_en || tool.name;

  return (
    <button
      onClick={() => onToolClick(tool.page_slug)}
      className="
        group w-full flex items-center justify-between
        bg-slate-700 border border-slate-700 
        hover:border-orange-500 hover:bg-slate-750
        rounded-lg px-3 py-2 transition-all duration-200
        h-12 overflow-hidden
      "
      title={displayName} // Tooltip in case text is cut off
    >
      <div className="flex items-center min-w-0">
        {/* Icon */}
        <div className="flex-shrink-0 mr-3 text-orange-500">
          <i className={`bi ${tool.icon} text-lg`}></i>
        </div>
        
        {/* Name - Truncated so it stays on one line */}
        <span className="text-gray-200 text-sm font-medium truncate group-hover:text-white">
          {displayName}
        </span>
      </div>

      {/* Free Badge - Small and compact */}
      {tool.is_free && (
        <span className="ml-2 flex-shrink-0 bg-green-500/20 text-green-400 text-[10px] px-1.5 py-0.5 rounded border border-green-500/30">
          {t('FREE')}
        </span>
      )}
    </button>
  );
};

export default ToolCard;
